import styled from "styled-components";
import { setFontVariant, colorsPalettes } from "@similarweb/styles";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const ItemsList = styled(FlexRow)`
    align-items: center;
`;

export const ChipWrapper = styled.div`
    ${setFontVariant("chip1", colorsPalettes.carbon[400])};
    margin-right: 12px;
`;
